/**
 * Имя канала, каким его сохранит сервер (backend/internal/guild channelName) — для подсказки
 * «Будет называться #…». Невидимые символы убираются у всех каналов; у текстовых — строчные
 * буквы, пробелы и знаки ASCII (кроме «_» и «-») становятся дефисами, как у Discord. Эмодзи
 * и нелатинские разделители («📢┃новости») остаются. Проверяет scripts/channel-name.test.mjs.
 */

// невидимые и управляющие символы, кроме склейки эмодзи (ZWJ) и тегов флагов
const INVISIBLE = /(?![‍\u{E0020}-\u{E007F}])[\p{Cc}\p{Cf}\p{Co}]/gu
const ASCII_MARKS = /[\x21-\x2C\x2E\x2F\x3A-\x40\x5B-\x5E\x60\x7B-\x7E]+/g

export function channelName(raw: string, text: boolean): string {
  const name = raw.replace(INVISIBLE, '').trim()
  if (!text) return name
  return name
    .toLowerCase()
    .split(/\s+/)
    .filter(Boolean)
    .join('-')
    .replace(ASCII_MARKS, '-')
    .replace(/^-+|-+$/g, '')
}
